import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FormControl, FormGroup} from "@angular/forms";
import {AbstractComponent} from "../abstract.component";
import {Organiser, OrganiserModule} from "@model";
import {TranslocoService} from "@ngneat/transloco";

@Component({
  selector: 'app-organiser-modules-modal',
  templateUrl: './organiser-modules-modal.component.html',
  styleUrl: './organiser-modules-modal.component.scss',
  standalone: false
})
export class OrganiserModulesModalComponent extends AbstractComponent{
  @Input() organiser!: Organiser;
  @Input() activeModules: OrganiserModule[] = [];

  modulesOptions: Map<string, string> = new Map<string, string>();

  constructor(public activeModal: NgbActiveModal,
              public translocoService: TranslocoService,
  ) {
    super();
  }

  inputForm = new FormGroup({
    modules: new FormControl(),
  });

  ngOnInit(): void {
    this.modulesOptions = this.getOptions();
    this.initForm();
  }

  getOptions(): Map<string, string> {
    const optionsMap = new Map<string, string>();
    optionsMap.set(OrganiserModule.EVENT_MANAGEMENT, this.translocoService.translate('app.common.modules.event_management'));
    optionsMap.set(OrganiserModule.LEAGUE_MANAGEMENT, this.translocoService.translate('app.common.modules.league_management'));
    return optionsMap;
  }

  private initForm() {
    this.inputForm.controls.modules.setValue(this.activeModules);
  }

  onConfirmClick(): void {
    const modules: OrganiserModule[] = this.inputForm.controls.modules.value;
    this.activeModal.close(modules);
  }

  onDismissClick(): void {
    this.activeModal.dismiss();
  }

}
